import React from 'react';

function Dashboard() {
    return (
        <div>
            <h1>Dashboard</h1>
            <p>Willkommen in der Makler-53 Buchhaltung.</p>
            <ul>
                <li>Anzahl Objekte: -</li>
                <li>Anzahl Angebote: -</li>
                <li>Anzahl Rechnungen: -</li>
                <li>Anzahl Referenzen: -</li>
                <li>Anzahl Provisionen: -</li>
            </ul>
        </div>
    );
}

export default Dashboard;
